import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function WasteReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
        header: "Reference",
        accessorKey: "Reference",
      },
    {
      header: "Date",
      accessorKey: "Date",
    },
   
    {
      header: "Total Loss",
      accessorKey: "Total Loss",
    },
    {
      header: "Ingredient Count",
      accessorKey: "Ingredient Count",
    },
    {
        header: "Responsible Person",
        accessorKey: "Responsible Person",
      },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "User",
    }, 
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Waste Report"}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default WasteReport;
